import { Box, Typography } from "@mui/material";
import { USE_BASE_URL } from "src/config";
import ResourceItem from "./components/resource-item";

const Resources = () => {
    return (
        <Box sx={{ textAlign: "left" }}>
            <Typography
                sx={{
                    color: "#fff",
                    fontSize: "13px",
                    fontWeight: "600",
                    letterSpacing: "1px",
                    mb: 2,
                    fontFamily:  "Montserrat, sans-serif"
                }}
            >
                RESOURCES
            </Typography>
            <ResourceItem href={`${USE_BASE_URL}/about-us/`} label="About us" />
            <ResourceItem
                href="https://btaftoken.io/files/whitePaper.pdf"
                label="Whitepaper"
            />

            <ResourceItem href="https://medium.com/@TAFtoken" label="Blog" />
            <ResourceItem href="https://help.btaftoken.io" label="Support" />
            <ResourceItem href={`${USE_BASE_URL}`} label="Media Kit" />
            <ResourceItem href={`https://bitcointaf.com/whisper-drop/`} label="Whisper Drop" />
            <ResourceItem href={`https://bitcointaf-com.gitbook.io/btaf-tokenomics/introduction-to-btaf-token/introduction-to-bitcointaf.com/welcome-what-is-bitcointaf.com`} label="Gitbook" />
        </Box>
    );
};

export default Resources;
